const SPANISH_LETTERS_AND_SPACES = /^[A-ZÁÉÍÓÚÜÑ ]+$/u;

export function isAllowedContentWord(word: string): boolean {
  return (
    word.length > 0 &&
    SPANISH_LETTERS_AND_SPACES.test(word) &&
    word.trim() === word
  );
}

export function normalizeWord(value: string): string {
  return value
    .toLocaleUpperCase("es-PE")
    .replace(/[ÁÀÄÂ]/gu, "A")
    .replace(/[ÉÈËÊ]/gu, "E")
    .replace(/[ÍÌÏÎ]/gu, "I")
    .replace(/[ÓÒÖÔ]/gu, "O")
    .replace(/[ÚÙÜÛ]/gu, "U")
    .replace(/\s+/gu, " ")
    .trim();
}

export function isSpanishLetter(value: string): boolean {
  return /^[A-ZÁÉÍÓÚÜÑ]$/u.test(value.toLocaleUpperCase("es-PE"));
}

export function nextExpectedCharacter(
  word: string,
  typedLength: number,
): {
  expected: string | null;
  index: number;
} {
  const normalized = normalizeWord(word);
  let index = typedLength;
  while (normalized[index] === " ") index += 1;
  return { expected: normalized[index] ?? null, index };
}

export function applyLetter(
  word: string,
  typedLength: number,
  letter: string,
): { correct: boolean; typedLength: number; complete: boolean } {
  const normalized = normalizeWord(word);
  const { expected, index } = nextExpectedCharacter(normalized, typedLength);
  if (expected === null || normalizeWord(letter) !== expected) {
    return { correct: false, typedLength, complete: false };
  }
  let next = index + 1;
  while (normalized[next] === " ") next += 1;
  return {
    correct: true,
    typedLength: next,
    complete: next >= normalized.length,
  };
}
